const apiUrl = process.env.REACT_APP_API_URL; // Add this line to define apiUrl


export default async function handleSubmit(setLoading, formData, setComplete) {
  setLoading(true);

  try {
    const res = await fetch(`${apiUrl}/create/signup`, {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify(formData),
    });

    // ─── try to read the body (may fail on 500 HTML, etc.) ───────────────
    let body = {};
    try {
      body = await res.json();
    } catch (_) {
      console.error('handleSubmit → could not parse JSON response');
      return { success: false, error: 'Invalid response from server' };
    }

    // ─── turn non-2xx into an error result ───────────────────────────────
    if (!res.ok) {
      console.error('handleSubmit → request failed:', body.error || res.status);
      return { success: false, error: body.error || `Request failed (${res.status})` };
    }

    // ✅ SUCCESS — only set complete if no errors and JSON is good
    setComplete(true);
    return { success: true, data: body };

  } catch (err) {
    console.error('handleSubmit → network/runtime error:', err);
    return { success: false, error: err.message || 'Unexpected error' };
  } finally {
    setLoading(false);
  }
}